var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "FormGroup",
    {
      attrs: {
        state: _vm.dateValid,
        "invalid-feedback": _vm.dateError,
        "feedback-beneath": ""
      }
    },
    [
      _c("b-input", {
        attrs: { placeholder: "TT.MM.JJJJ (z.B. 19.11.1979)" },
        on: { input: _vm.emitChangeEvent },
        model: {
          value: _vm.dateString,
          callback: function($$v) {
            _vm.dateString = $$v
          },
          expression: "dateString"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }